import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "quickform" }
const _hoisted_2 = { class: "quickform__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "quickform__content" }

import { QuickformTab } from "@/modules/Quickform/models/QuickformTab";
import { shallowRef } from "vue";

interface Props {
  tabs: QuickformTab[];
  activeTabIndex?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseWidget',
  props: {
    tabs: {},
    activeTabIndex: {}
  },
  setup(__props: any) {

const props = __props;
const currentTab = shallowRef(props.tabs[props.activeTabIndex ?? 0]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: ($event: any) => (currentTab.value = tab),
            class: _normalizeClass(["tab", { active: currentTab.value?.code === tab.code }]),
            key: tab.code
          }, [
            (tab.component)
              ? (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(tab.label), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentTab.value?.component), {
          class: "tab",
          tab: currentTab.value
        }, null, 8, ["tab"]))
      ], 1024))
    ])
  ]))
}
}

})